import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

function ReferencesPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>References</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              <ol>
                <li>
                  Ramachandra TV, Sincy V, Asulabha KS (2021) Accounting of
                  ecosystem services of wetlands in Karnataka State, India. JRED
                  18(1-2):1-26
                </li>
                <li>
                  Ramachandra TV, Sudarshan PB, Mahesh MK, Vinay S (2018)
                  Spatial patterns of heavy metal accumulation in sediments and
                  macrophytes of Bellandur wetland, Bangalore. J Environ Manage
                  206: 1204-1210. https://doi.org/10.1016/j.jenvman.2017.10.014
                </li>
                <li>
                  N&auml;schen K, Diekkr&uuml;ger B, Evers M, H&ouml;llermann B,
                  Steinbach S, Thonfeld F (2019) The impact of land use/land
                  cover change (LULCC) on water resources in a tropical
                  catchment in Tanzania under different climate change
                  scenarios. Sustainability 11(24):7083.
                  https://doi.org/10.3390/su11247083
                </li>
                <li>
                  Bera T, Kumar V, Sarkar DJ, Devi MS, Behera BK, Das BK (2022)
                  Pollution assessment and mapping of potentially toxic elements
                  (PTE) distribution in urban wastewater fed natural wetland,
                  Kolkata, India. Environ Sci Pollut Res 29:67801-67820.
                  https://doi.org/10.1007/s11356-022-20573-8
                </li>
                <li>
                  Singh Y, Singh G, Khattar JS, Barinova S, Kaur J, Kumar S,
                  Singh DP (2022) Assessment of water quality condition and
                  spatiotemporal patterns in selected wetlands of Punjab, India.
                  Environ Sci Pollut Res 29:2493-2509.
                  https://doi.org/10.1007/s11356-021-15590-y
                </li>
                <li>
                  Ramachandra TV, Asulabha KS, Lone AA (2014) Nutrient
                  enrichment and proliferation of invasive macrophytes in urban
                  lakes. J Biodivers 5(1-2):33-44
                </li>
                <li>
                  Bassi N, Kumar MD, Sharma A, Pardha-Saradhi P (2014) Status of
                  wetlands in India: A review of extent, ecosystem benefits,
                  threats and management strategies. J Hydrol Reg Stud 2:1-19.
                  https://doi.org/10.1016/j.ejrh.2014.07.001
                </li>
                <li>
                  Rowe GL, Reutter DC, Runkle DL, Berkman JAH, Janosy SD, Hwang
                  LS (2004) Water Quality in the Great and Little Miami River
                  Basins, Ohio and Indiana, 1999&ndash;2001 (No. 1229). US
                  Geological Survey
                </li>
                <li>
                  Kamboj V, Kamboj N, Sharma AK, Bisht A (2022) Fish diversity
                  associated with environmental parameters in impacted area of
                  Ganga River, India. Proceedings of the National Academy of
                  Sciences, India Section B: Biological Sciences
                  93(1):79&ndash;90. https://doi.org/10.1007/s40011-022-01393-9
                </li>
                <li>
                  Rahimi M, Zarei M, Keshavarzi B, Golshani R, Zafarani SGG
                  (2023) Water quality stress to Amirkalayeh wetland, Northern
                  Iran. Environ Monit Assess 195(1):49.
                  https://doi.org/10.1007/s10661-022-10691-8
                </li>
                <li>
                  Ramachandra TV, Sudarshan P, Vinay S, Asulabha KS, Varghese S
                  (2020) Nutrient and heavy metal composition in select biotic
                  and abiotic components of Varthur wetlands, Bangalore, India.
                  SN Appl Sci 2:1-14
                </li>
                <li>
                  Hong Z, Zhao Q, Chang J, Peng L, Wang S, Hong Y, Liu G, Ding S
                  (2020) Evaluation of water quality and heavy metals in
                  wetlands along the Yellow River in Henan Province.
                  Sustainability, 12:1300. doi:10.3390/su12041300
                </li>
                <li>
                  Ramachandra TV, Shivamurthy V, Subramanian AK, Varghese S,
                  Setturu B, Aithal BH (2022) Appraisal of environmental health
                  and ecohydrology of free-flowing Aghanashini River, Karnataka,
                  India. Water 14(6):977. https://doi.org/10.3390/w14060977
                </li>
                <li>
                  Samal DR, Gedam S (2021) Assessing the impacts of land use and
                  land cover change on water resources in the Upper Bhima River
                  basin, India. Environ Chall 5:100251.
                  https://doi.org/10.1016/j.envc.2021.100251
                </li>
                <li>
                  Sun T, Cheng W, Abdelkareem M, Al-Arifi N (2022) Mapping
                  prospective areas of water resources and monitoring land
                  use/land cover changes in an arid region using remote sensing
                  and GIS techniques. Water 14(15):2435.
                  https://doi.org/10.3390/w14152435
                </li>
                <li>
                  Aghsaei H, Dinan NM, Moridi A, Asadolahi Z, Delavar M, Fohrer
                  N, Wagner PD (2020) Effects of dynamic land use/land cover
                  change on water resources and sediment yield in the Anzali
                  wetland catchment, Gilan, Iran. Sci Total Env 712:136449.
                  https://doi.org/10.1016/j.scitotenv.2019.136449
                </li>
                <li>
                  Cao W, Bowden WB, Davie T, Fenemor A (2009) Modelling impacts
                  of land cover change on critical water resources in the
                  Motueka River catchment, New Zealand. Water Resour Manag
                  23:137-151. https://doi.org/10.1007/s11269-008-9268-2
                </li>
                <li>
                  Liu Y, Wang D, Gao J, Deng W (2005) Land use/cover changes,
                  the environment and water resources in Northeast China.
                  Environ Manage 36:691-701.
                  https://doi.org/10.1007/s00267-004-0285-5
                </li>
                <li>
                  Ramachandra TV, Mondal T, Setturu B, Aithal BH (2023)
                  Environmental consequences in the neighbourhood of rapid
                  unplanned urbanisation in Bangalore City. AEER 4(4):052.
                  doi:10.21926/aeer.2304052
                </li>
                <li>
                  Ramachandra TV, Kumar U (2008) Wetlands of greater Bangalore,
                  India: Automatic delineation through pattern classifiers.
                  Electron Green J (26):2
                </li>
                <li>
                  Sudhira, H. S., Ramachandra, T. V., &amp; Subrahmanya, M. B.
                  (2007). Bangalore. Cities, 24(5), 379-390.
                  https://doi.org/10.1016/j.cities.2007.04.003
                </li>
                <li>
                  APHA, AWWA, WEF (2012) Standard Methods for Examination of
                  Water and Waste Water. 22nd Edition, American Public Health
                  Association, Washington DC
                </li>
                <li>
                  Desikachary TV (1959) Cyanophyta. Indian Council for
                  Agricultural Research, New Delhi
                </li>
                <li>
                  Prescott GW (1970) How to Know Freshwater Algae.2nd ed., W.C.
                  Brown. Dubuque, Iowa
                </li>
                <li>AlgaeBase, (2023). https: //www.algaebase.org/</li>
                <li>
                  Zooplankton Database.
                  https://www.dfo-mpo.gc.ca/science/data-donnees/plankton-plancton/basedonnees-zooplankton-database-eng.html
                </li>
                <li>
                  Jayaram KC (1999) The fresh water fisheries of Indian region.
                  New Delhi: Narendra Publishing House
                </li>
                <li>
                  Talwar PK, Jhingram AG (1991) Inland fishes of India and
                  adjacent countries. New Delhi: Oxford and IBH co. Private
                  limited
                </li>
                <li>Fish Base (2023). https://fishbase.mnhn.fr/home.htm</li>
                <li>Cronk JK, Fennessy MS (2001) Wetland Plants. CRC Press</li>
                <li>
                  Ramaswamy SV, Razi BA (1973) Flora of Bangalore District.
                  Kapila Power Press, Mysore, India
                </li>
                <li>
                  Ramachandra TV, Asulabha KS, Sincy V, Bhat S, &amp; Aithal BH
                  (2016) Wetlands: Treasure of Bangalore. ENVIS Technical Report
                  101, Environmental Information System, Centre for Ecological
                  Sciences (CES), Indian Institute of Science, Bangalore 560012
                </li>
                <li>
                  Dudgeon D, Arthington AH, Gessner MO, Kawabata ZI, Knowler DJ,
                  L&eacute;v&ecirc;que C, Naiman RJ, Prieur-Richard AH, Soto D,
                  Stiassny ML, Sullivan CA (2006) Freshwater biodiversity:
                  importance, threats, status and conservation challenges. Biol
                  Rev 81(2):163-182. doi:10.1017/S1464793105006950
                </li>
                <li>
                  Asulabha KS, Jaishanker R, Sincy V, Ramachandra TV (2022).
                  Diversity of phytoplankton in lakes of Bangalore, Karnataka,
                  India. 10th Chapter, In: Shashikanth Majige (eds),
                  Biodiversity Challenges: A way forward, Daya Publishing House,
                  New Delhi, 147-178
                </li>
                <li>
                  Ramachandra TV, Mahapatra DM, Bhat SP, Joshi NV (2015) Biofuel
                  production along with remediation of sewage water through
                  algae. In: Singh, B., Bauddh, K., Bux, F. (eds) Algae and
                  Environmental Sustainability. Developments in Applied
                  Phycology, vol 7. Springer, New Delhi.
                  https://doi.org/10.1007/978-81-322-2641-3_4
                </li>
                <li>
                  Sincy V, Asulabha KS, Ramachandra TV (2016) Bio-monitoring of
                  lentic ecosystems through Zooplanktons, Proceedings of Kerala
                  Environment Congress 2016: Vinod T.R., Sabu T., Thrivikramji
                  K.P., Babu Ambat (Eds.). Published by Centre for Environment
                  and Development, Thiruvananthapuram, Kerala, India.
                </li>
                <li>
                  Ejsmont-Karabin J, Karpowicz M (2021) Rotifera in lake
                  subhabitats. Aquatic Ecol 55:1285&ndash;1296.
                  https://doi.org/10.1007/s10452-020-09818-1
                </li>
                <li>
                  Sincy V, Jaishanker R, Asulabha KS, Ramachandra TV (2022)
                  Diversity of phytoplankton in lakes of Bangalore, Karnataka,
                  India. 10th Chapter, In: Shashikanth Majige (eds),
                  Biodiversity Challenges: A way forward, Daya Publishing House,
                  New Delhi, 115-146.
                </li>
                <li>
                  Gaston KJ (2022) Birds and ecosystem services. Curr Biol
                  32(20):R1163-R1166
                </li>
                <li>
                  Whelan CJ, Şekercioğlu &Ccedil;H, Wenny DG (2015) Why birds
                  matter: from economic ornithology to ecosystem services. J
                  Ornithol 156:227-238. DOI 10.1007/s10336-015-1229-y
                </li>
                <li>
                  Yusa Y, Sugiura N, Wada T (2006) Predatory potential of
                  freshwater animals on an invasive agricultural pest, the apple
                  snail <em>Pomacea canaliculata</em> (Gastropoda:
                  Ampullariidae), in southern Japan. Biol Invasions 8:137-147
                </li>
                <li>
                  Green AJ, Elmberg J (2014) Ecosystem services provided by
                  waterbirds. Biol Rev 89(1):105-122. doi: 10.1111/brv.12045
                </li>
                <li>
                  Ramachandra TV, Rajinikanth R, Ranjini VG (2005) Economic
                  valuation of wetlands. J Environ Biol 26(2):439-447
                </li>
                <li>
                  Ramachandra TV, Aithal BH, Kumar U (2012) Conservation of
                  wetlands to mitigate urban floods. JRED 9(1):1-22
                </li>
                <li>
                  Ramachandra TV, Meera DS, Alakananda B (2013) Influence of
                  catchment land cover dynamics on the physical, chemical and
                  biological integrity of wetlands. Env We: Int J Sci Technol
                  8(1):37-54
                </li>
                <li>
                  Arsiso BK, Tsidu GM, Abegaz NT (2023) Impact of land use and
                  land cover change on land surface temperature over Lake Tana
                  Basin. J Afr Earth Sci 207:1-16.
                  https://doi.org/10.1016/j.jafrearsci.2023.105047
                </li>
                <li>
                  Muro J, Strauch A, Heinemann S, Steinbach S, Thonfeld F, Waske
                  B, Diekkr&uuml;ger B (2018) Land surface temperature trends as
                  indicator of land use changes in wetlands. Int J Appl Earth
                  Obs Geoinf 70:62-71. https://doi.org/10.1016/j.jag.2018.02.002
                </li>
                <li>
                  Johnstone C, Bedaso ZK, Ekberg M (2022) Characterizing surface
                  water and groundwater interaction for sustainable water
                  resources management in southwestern Ohio. Sustain Water
                  Resour Manag 8:1-16.
                  https://doi.org/10.1007/s40899-021-00598-6
                </li>
                <li>
                  Winter TC, Harvey JW, Franke OL, Alley WM (1998) Ground water
                  and surface water: a single resource (Vol. 1139). US
                  geological Survey
                </li>
                <li>
                  Wu X, Ma T, Wang Y (2020) Surface water and groundwater
                  interactions in wetlands. J Earth Sci 31(5): 1016-1028.
                  https://doi.org/10.1007/s12583-020-1333-7
                </li>
                <li>
                  Ramachandra TV, Sincy V, Asulabha KS, Mahapatra DM, Bhat SP,
                  Aithal BH (2018) Optimal treatment of domestic wastewater
                  through constructed wetlands. J Biodivers 9:81-102
                </li>
                <li>
                  Mahapatra DM, Chanakya HN, Ramachandra TV (2011) Assessment of
                  treatment capabilities of Varthur lake, Bangalore, India. Int
                  J Environ Technol Manag 14(1-4):84-102
                </li>
                <li>
                  Paruch L, Paruch AM, Eiken HG, S&oslash;rheim R (2019) Faecal
                  pollution affects abundance and diversity of aquatic microbial
                  community in anthropo-zoogenically influenced lotic
                  ecosystems. Sci Rep 9(1):19469.
                  https://doi.org/10.1038/s41598-019-56058-x
                </li>
                <li>
                  Ramachandra TV, Alakananda B, Rani A, Khan MA (2011)
                  Ecological and socio-economic assessment of Varthur Wetland,
                  Bengaluru (India). J Environ Sci Eng 53(1):101-108
                </li>
                <li>
                  Sudarshan P, Mahesh MK, Ramachandra TV (2019) Assessment of
                  seasonal variation in water quality and water quality index
                  (WQI) of Hebbal Lake, Bangalore, India. Environ Ecol
                  37(1B):309-317
                </li>
                <li>
                  Ramachandra TV, Asulabha KS, Sincy V (2021) Phosphate loading
                  and foam formation in urban lakes. G P Glob Res J Chem
                  5(1):33-52
                </li>
                <li>
                  Ramachandra TV, Shwetmala (2012) Decentralised carbon
                  footprint analysis for opting climate change mitigation
                  strategies in India. Renew Sust Energ Rev 16(8):5820-5833.
                  https://doi.org/10.1016/j.rser.2012.05.035
                </li>
                <li>
                  Naveen BP, Mahapatra DM, Sitharam TG, Sivapullaiah PV,
                  Ramachandra TV (2017) Physico-chemical and biological
                  characterization of urban municipal landfill leachate. Environ
                  Pollut 220:1-12. https://doi.org/10.1016/j.envpol.2016.09.002
                </li>
                <li>
                  Ramachandra TV, Sincy V, Asulabha KS, Bhat S, Rahaman MF
                  (2016) Recurring Fish Mortality Episodes in Bangalore Lakes:
                  Sign of Irresponsible and Fragmented Governance. ENVIS
                  Technical Report 105, Environmental Information System, Centre
                  for Ecological Sciences (CES), Indian Institute of Science,
                  Bangalore 560012
                </li>
                <li>
                  Benjamin R, Chakrapani BK, Devashish K, Nagarathna AV,
                  Ramachandra TV (1996) Fish mortality in Bangalore lakes,
                  India. Electron Green J, 1(6):1-8
                </li>
                <li>
                  San Diego-McGlone ML, Azanza RV, Villanoy CL, Jacinto GS
                  (2008) Eutrophic waters, algal bloom and fish kill in fish
                  farming areas in Bolinao, Pangasinan, Philippines. Mar Pollut
                  Bull 57(6-12):295-301.
                  https://doi.org/10.1016/j.marpolbul.2008.03.028
                </li>
                <li>
                  Hoyer MV, Watson DL, Willis DJ, Canfield Jr DE (2009) Fish
                  kills in Florida&rsquo;s canals, creeks/rivers, and
                  ponds/lakes. J Aquat Plant Manag 47(1):53-56
                </li>
                <li>
                  Sarkar UK, Dubey VK, Singh AK, Gupta BK, Pandey A, Sani RK,
                  Lakra WS (2012) The recent occurrence of exotic freshwater
                  fishes in the tributaries of river Ganga basin: abundance,
                  distribution, risk, and conservation issues. The
                  Environmentalist 32:476-484.
                  https://doi.org/10.1007/s10669-012-9412-7
                </li>
                <li>
                  Prasad SN, Ramachandra TV, Ahalya N, Sengupta T, Kumar A,
                  Tiwari AK, Vijayan VS, Vijayan L (2002) Conservation of
                  wetlands of India - a review. Trop Ecol 43(1):173-186
                </li>
                <li>
                  Ramachandra TV, Sincy V, Asulabha KS (2020) Efficacy of
                  rejuvenation of lakes in Bengaluru, India. Green Chemistry and
                  Technology Letters, GCTL 6(1):14-26
                </li>
                <li>
                  Ramachandra TV, Mahapatra DM, Vinay S, Sincy V, Asulabha KS,
                  Bhat SP, Aithal BH (2017) Bellandur and Varthur Lakes
                  Rejuvenation Blueprint. ENVIS Technical Report 116,
                  Environmental Information System, Centre for Ecological
                  Sciences (CES), Indian Institute of Science, Bangalore 560012
                </li>
                <li>
                  Mahapatra DM, Joshi NV, Ramachandra TV (2018) Insights to
                  bioprocess and treatment competence of urban wetlands. J
                  Environ Manage 206:1179-1191
                </li>
                <li>
                  Ramachandra T.V., Aithal B.H., Setturu, B., Vinay S., Asulabha
                  K.S., &amp; Sincy V. (2024). Natural Capital Accounting and
                  Valuation of Aquatic Ecosystem Services in Karnataka, India.
                  In: Natural Capital Accounting and Valuation of Ecosystem
                  Services, Karnataka State, India. Springer, Singapore.
                  https://doi.org/10.1007/978-981-97-2405-5_5
                </li>
              </ol>
            </p>
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default ReferencesPage;
